// FAQ Content - Adapted from iAngels.com

export const faqContent = {
  title: "Frequently Asked Questions",
  categories: [
    {
      name: "Getting Started",
      questions: [
        {
          question: "What is Angels67?",
          answer: "Angels67 is a venture capital platform that provides individual investors access to Israeli tech startups. We offer three investment vehicles: Angels67 Capital (self-directed), Angels67 Ventures (managed portfolios), and Angels67 Digital Assets (blockchain focus)."
        },
        {
          question: "Who can invest with Angels67?",
          answer: "Angels67 is open to accredited investors and sophisticated individuals who meet regulatory requirements. Minimum investment amounts vary by investment vehicle."
        },
        {
          question: "How do I get started?",
          answer: "Sign up for a free account, complete your investor profile and accreditation verification, browse available opportunities, and start investing in the startups that match your interests and goals."
        },
        {
          question: "What are the fees?",
          answer: "Fee structures vary by investment vehicle. Angels67 Capital has transparent per-deal fees, while Angels67 Ventures and Digital Assets follow a traditional management fee plus performance fee structure. All fees are disclosed upfront."
        }
      ]
    },
    {
      name: "Investment Process",
      questions: [
        {
          question: "How are startups selected?",
          answer: "We employ a rigorous due diligence process, evaluating hundreds of startups annually. Our team analyzes market opportunity, team quality, technology differentiation, business model, and growth potential. Only the most promising companies make it to our platform."
        },
        {
          question: "What information do I receive about startups?",
          answer: "Investors receive comprehensive due diligence materials including pitch decks, financial models, market analysis, competitive landscape, team backgrounds, cap table information, and investment terms."
        },
        {
          question: "What is the minimum investment?",
          answer: "Minimum investments vary: Angels67 Capital typically requires $1,000-$10,000 per deal, Angels67 Ventures starts at $50,000 for a managed portfolio, and Angels67 Digital Assets has a $100,000 minimum."
        },
        {
          question: "How long until I see returns?",
          answer: "Venture capital is a long-term investment. Typical holding periods range from 5-10 years. Some companies may exit earlier through acquisition, while others may take longer to mature. Past performance: 24 profitable exits to date."
        }
      ]
    },
    {
      name: "Portfolio & Returns",
      questions: [
        {
          question: "Can I choose which startups to invest in?",
          answer: "Yes, with Angels67 Capital you have full control over your investment decisions. Angels67 Ventures offers a curated portfolio built with your preferences, while Digital Assets is fully managed by our team."
        },
        {
          question: "How do I track my investments?",
          answer: "Your dashboard provides real-time portfolio tracking, including current valuations, investment history, performance metrics, and upcoming opportunities. You'll also receive quarterly updates from portfolio companies."
        },
        {
          question: "What happens if a startup fails?",
          answer: "Venture capital carries inherent risks. Not all startups succeed, which is why diversification is crucial. Our platform encourages building a diversified portfolio across multiple companies, stages, and sectors to mitigate risk."
        },
        {
          question: "How are exits handled?",
          answer: "When a portfolio company is acquired or goes public, proceeds are distributed to investors according to their ownership stake, minus any applicable fees. We handle all administrative aspects of the exit process."
        }
      ]
    },
    {
      name: "Platform Features",
      questions: [
        {
          question: "Is my information secure?",
          answer: "Yes. We employ bank-level security measures including 256-bit encryption, two-factor authentication, secure data storage, and regular security audits. Your personal and financial information is protected."
        },
        {
          question: "Can I invest through an entity?",
          answer: "Yes, we accept investments from trusts, LLCs, corporations, and other legal entities. Additional documentation may be required for entity verification."
        },
        {
          question: "Do you offer investor education?",
          answer: "Yes! We provide extensive resources including webinars, research reports, glossary of terms, investment guides, and access to our expert team for questions."
        },
        {
          question: "What sectors do you focus on?",
          answer: "We focus on Israeli technology companies across key sectors: AI & Machine Learning, Cybersecurity, FinTech, HealthTech, CleanTech, Enterprise Software, and Digital Assets/Blockchain."
        }
      ]
    }
  ],

  cta: {
    title: "Still have questions?",
    description: "Our team is here to help. Contact us for personalized assistance.",
    email: "team@angels67.com",
    phone: "+972 3 901 3760"
  }
};

export default faqContent;
